// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__S7crAv9rtt{margin-left:calc(var(--dixa-size-spacer-250)*-1)}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/search/components/results/components/types/contacts/components/dropdown/contactTypeDropdown.module.scss"],"names":[],"mappings":"AAEA,kBACE,gDAAA","sourcesContent":["@use '@dixa/lib-shared-tokens/scss' as *;\n\n.root {\n  margin-left: minus(var(--dixa-size-spacer-250));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__S7crAv9rtt`
};
export default ___CSS_LOADER_EXPORT___;
